import { render, staticRenderFns } from "./TableWrapper.vue?vue&type=template&id=fc34c002&scoped=true&"
import script from "./TableWrapper.vue?vue&type=script&lang=js&"
export * from "./TableWrapper.vue?vue&type=script&lang=js&"
import style0 from "./TableWrapper.vue?vue&type=style&index=0&id=fc34c002&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc34c002",
  null
  
)

export default component.exports